// QOMX DEX contract addresses (Uniswap V2 fork on QOM/QL1)
export const QOMX_ROUTER_ADDRESS = '0x49AfA8819625b409963B9891F36d1b368AdaAb6c'
export const QOMX_FACTORY_ADDRESS = '0xb3e66a40f65109b44a1de55611c0be5566561797'
export const QOMX_WETH_ADDRESS = '0xa26dfbf98dd1a32fae56a3d2b2d60a8a41b0bdf0'

// Q Stablecoin - bridged via QOMX
export const Q_TOKEN_ADDRESS = '0xC3D374365d184bd0A24645778B29A9dfC20Ead01'

// Helper: check if a swap involves Q token (route via QOMX router)
export const isQSwap = (inputAddress?: string, outputAddress?: string): boolean => {
  if (!inputAddress && !outputAddress) return false
  const qLower = Q_TOKEN_ADDRESS.toLowerCase()
  return (
    inputAddress?.toLowerCase() === qLower || outputAddress?.toLowerCase() === qLower
  )
}
